"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fedopsLogger = exports.fedopsLoggerFactory = void 0;
const fedops_logger_1 = require("@wix/fedops-logger");
const constants_1 = require("./constants");
const fedopsLoggerFactory = (appName) => (0, fedops_logger_1.create)(appName);
exports.fedopsLoggerFactory = fedopsLoggerFactory;
exports.fedopsLogger = (0, exports.fedopsLoggerFactory)(constants_1.FEDOPS_LOGGER_ID);
//# sourceMappingURL=index.js.map